<template lang="jade">
  include ./mixin.jade
  +simpleGetButton('dxGetInputResolution')
  +simpleGetButton('dxGetOutputResolutionOptions')
  +simpleGetButton('dxGetOutputResolution')
  .row
    .col-xs-12
      fieldset
        legend dxSetOutputResolution
        +simpleInput('outputRes.port')
        +simpleInput('outputRes.option')
        button(@click="dxSetOutputResolution") dxSetOutputResolution
  +simpleGetButton('dxGetSplitOptions')
  +simpleGetButton('dxGetSplitArea')
  .row
    .col-xs-12
      fieldset
        legend dxSetSplitArea
        div(v-for="(id, sval) in splitArea" track-by="$index")
          span port : {{ id }}
          input.thin(number v-model="v" v-for="v in sval" track-by="$index" )
        button(@click="dxSetSplitArea") dxSetSplitArea
</template>

<style scoped>
  .thin {
    width: 16%;
  }
</style>
<script>
  export default {
    data: () => ({
      profile: {
        pid: '1',
        content: {
          name: 'custom 1',
          mapping: {
            1: '4',
            2: '4',
            3: '4',
            4: '4'
          },
          layer: [1, 3, 2, 4],
          split: {
            1: [0, 0, 960, 540, 0],
            2: [960, 0, 1920, 540, 0],
            3: [0, 540, 960, 1080, 0],
            4: [960, 540, 1920, 1080, 0]
          }
        }
      },
      outputRes: {
        port: '1',
        option: '3'
      },
      splitLayer: [1, 2, 3, 4],
      splitArea: {
        1: [0, 0, 960, 540, 0],
        2: [960, 0, 1920, 540, 0],
        3: [0, 540, 960, 1080, 0],
        4: [960, 540, 1920, 1080, 0]
      },
      mapping: {
        1: '3',
        2: '3',
        3: '3',
        4: '3'
      }
    }),
    methods: {
      sendAPI (cmd, params) {
        this.$dispatch('sendAPI', cmd, params)
      },
      dxSetOutputResolution () {
        this.sendAPI('dxSetOutputResolution', {
          resolution: {
            [this.outputRes.port]: this.outputRes.option
          }
        })
      },
      dxSetSplitArea () {
        this.sendAPI('dxSetSplitArea', {
          setting: this.splitArea
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// splitter.vue?499641ff